import { uriConstants, userinfoConstants, authConstants } from '../../constants'
import { defaultService } from '../../services'
import { errorMessages } from '../../messages'
import { alertActions } from '../'
import history from '../../../route/history'
import axios from 'axios'

export const userinfoActions = {
  load,
  updateUserInfo,
  updatePass,
  retireUser,
  setHomeAddress,
  updateInactive,
  updateEwalletId,
  deleteEwalletId,
  passwdModDt,
  setDeviceId,
  kakaoLogin,
  naverLogin,
  snsLoad,
  snsLoginDisconnect,
  addKakaoLoginMobile,
  addNaverLoginMobile,
  setSignData,
}

/*******************
 method 반드시 이렇게..

 GET    = Read
 POST   = Create
 PUT    = Update
 DELETE = Delete
 ********************/

/*********
 로딩
 **********/

function load() {
  return async (dispatch) => {
    dispatch(request())

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_USERINFO,
      })
      .then(
        (response) => {
          // console.log('response = = = = ', response)
          dispatch(success(response))
        },
        (error) => {
          localStorage.removeItem('user')
          localStorage.removeItem('groupCode')
          dispatch({ type: authConstants.LOGOUT })
          dispatch(failure(error))
          dispatch(
            alertActions.error({
              title: null,
              message: error.response?.data?.errors?.message ? error.response?.data?.errors?.message : errorMessages.systemError,
            }),
          )
        },
      )
  }
  function request() {
    return {
      type: userinfoConstants.LOAD_REQUEST,
    }
  }
  function success(response) {
    return {
      type: userinfoConstants.LOAD_SUCCESS,
      response,
    }
  }
  function failure(response) {
    return {
      type: userinfoConstants.LOAD_FAILURE,
      response,
    }
  }
}

function passwdModDt(params) {
  return async (dispatch) => {
    dispatch(request())
    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    defaultService
      .handleService({
        method: 'put',
        endPoint: uriConstants.API_URI + uriConstants.UPDATE_PASSWD_MODDT + paramStr,
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
          dispatch(apiError(error))
        },
      )
  }
  function request() {
    return {
      type: userinfoConstants.MODDT_REQUEST,
    }
  }
  function success(response) {
    return {
      type: userinfoConstants.MODDT_SUCCESS,
      response,
    }
  }
  function failure(response) {
    return {
      type: userinfoConstants.MODDT_FAILURE,
      response,
    }
  }
}

/*********
 사용자정보 저장
 **********/

function updateUserInfo(params) {
  return async (dispatch) => {
    dispatch(request())

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    defaultService
      .handleService({
        method: 'put',
        endPoint: uriConstants.API_URI + uriConstants.GET_USERINFO + paramStr,
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
          // 기존 본인인증(CI)과 다른 CI 로 변경 시도: 서버가 payload.code = 'CI_MISMATCH' 로 알려준다.
          // 일반 오류 알림 대신 "본인인증 실패" 팝업을 띄우고, 닫을 때 새로고침해 다른 사람 인증 결과가 폼에 남지 않게 한다.
          if (error.response?.data?.payload?.code === 'CI_MISMATCH') {
            const reload = () => window.location.reload()
            dispatch(
              alertActions.success({
                title: '본인인증 실패',
                message: error.response?.data?.errors?.message || errorMessages.systemError,
                params: { type: 'SUCCESS', callback: reload, cancelCallback: reload },
              }),
            )
            return
          }
          dispatch(apiError(error))
        },
      )
  }
  function request() {
    return {
      type: userinfoConstants.UPDATE_REQUEST,
    }
  }
  function success(response) {
    return {
      type: userinfoConstants.UPDATE_SUCCESS,
      response,
    }
  }
  function failure(response) {
    return {
      type: userinfoConstants.UPDATE_FAILURE,
      response,
    }
  }
}

/*********
 비밀번호 변경
 **********/

function updatePass(params) {
  return async (dispatch) => {
    dispatch(request())

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    defaultService
      .handleService({
        method: 'put',
        endPoint: uriConstants.API_URI + uriConstants.SET_PASSWORD + paramStr,
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
          dispatch(apiError(error))
        },
      )
  }
  function request() {
    return {
      type: userinfoConstants.PASSWORD_REQUEST,
    }
  }
  function success(response) {
    return {
      type: userinfoConstants.PASSWORD_SUCCESS,
      response,
    }
  }
  function failure(response) {
    return {
      type: userinfoConstants.PASSWORD_FAILURE,
      response,
    }
  }
}

/*********
 회원탈퇴
 **********/

function retireUser(params) {
  return async (dispatch) => {
    dispatch(request())

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    defaultService
      .handleService({
        method: 'put',
        endPoint: uriConstants.API_URI + uriConstants.SET_USERINFO + paramStr,
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
          dispatch(apiError(error))
        },
      )
  }
  function request() {
    return {
      type: userinfoConstants.RETIRE_REQUEST,
    }
  }
  function success(response) {
    return {
      type: userinfoConstants.RETIRE_SUCCESS,
      response,
    }
  }
  function failure(response) {
    return {
      type: userinfoConstants.RETIRE_FAILURE,
      response,
    }
  }
}

/*********
 사용자가 입력한 주소로 update
 **********/

function setHomeAddress(item) {
  return (dispatch) => {
    dispatch(request(item))
  }

  function request(item) {
    let addressObj = {}

    addressObj.roadAddr = item.roadAddr
    addressObj.zipno = item.zipNo

    return {
      type: userinfoConstants.CHANGE_ADDRESS,
      addressObj,
    }
  }
}

/*********
 사용자 휴면설정(전자지갑 휴면신청)
 **********/

function updateInactive(params) {
  return async (dispatch) => {
    dispatch(request())

    const queryString = require('query-string')
    let paramStr = queryString.stringify(params)
    paramStr.length > 0 && (paramStr = '?' + paramStr)

    defaultService
      .handleService({
        method: 'put',
        endPoint: uriConstants.API_URI + uriConstants.SET_INACTIVE + paramStr,
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
          dispatch(
            alertActions.error({
              title: null,
              message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
            }),
          )
        },
      )
  }
  function request() {
    return {
      type: userinfoConstants.INACTIVE_REQUEST,
    }
  }
  function success(response) {
    return {
      type: userinfoConstants.INACTIVE_SUCCESS,
      response,
    }
  }
  function failure(response) {
    return {
      type: userinfoConstants.INACTIVE_FAILURE,
      response,
    }
  }
}

/*********
 사용자 전자지갑 주소 업데이트
 **********/
function updateEwalletId(mobileNo, certCi, mobileCertDt) {
  const queryString = require('query-string')
  let paramStr = queryString.stringify({ mobileNo, certCi, mobileCertDt })
  paramStr.length > 0 && (paramStr = '?' + paramStr)

  return (dispatch) => {
    dispatch(apiAction(userinfoConstants.UPDATE_EWALLET_ID_REQUEST))

    defaultService
      .handleService({
        method: 'put',
        endPoint: uriConstants.API_URI + uriConstants.UPDATE_EWALLET_ID + paramStr,
      })
      .then(
        (response) => {
          dispatch(apiAction(userinfoConstants.UPDATE_EWALLET_ID_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(userinfoConstants.UPDATE_EWALLET_ID_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}
/*********
 사용자 전자지갑 삭제 업데이트
 **********/
function deleteEwalletId() {
  return (dispatch) => {
    dispatch(apiAction(userinfoConstants.DELETE_EWALLET_ID_REQUEST))

    defaultService
      .handleService({
        method: 'put',
        endPoint: uriConstants.API_URI + uriConstants.DELETE_EWALLET_ID,
      })
      .then(
        (response) => {
          dispatch(apiAction(userinfoConstants.DELETE_EWALLET_ID_SUCCESS, response))
        },
        (error) => {
          dispatch(apiAction(userinfoConstants.DELETE_EWALLET_ID_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
}
/**
 * API 액션 함수
 */
function apiAction(type, response = null) {
  let resultObj = { type }
  response && (resultObj.response = response)
  return resultObj
}

function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
  })
}

/**
 * 디바이스 아이디
 */
function setDeviceId(deviceId) {
  return {
    type: userinfoConstants.SET_DEVICE_ID,
    deviceId,
  }
}

/*********
 kakao 로그인 등록
 **********/

function kakaoLogin(params) {
  console.log('~~~~~~~~~~~error~~~~-0~~~')
  return (dispatch) => {
    dispatch(request())
    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + '/portal/oauth/callback/kakao?code=' + params,
      })
      .then(
        (response) => {
          // console.log('~~~~~~~~~~~response~~~~~~~', response)
          console.log('~~~~~~~~~~~error~~~~0~~~')
          dispatch(success(response))
        },
        (error) => {
          // dispatch(apiAction(userinfoConstants.ADD_SNSLOGIN_FAILURE, error))
          //dispatch(apiError(error))
          console.log('~~~~~~~~~~~error~~~~1~~~', error)
          dispatch(failure(error))
        },
      )
  }
  function request() {
    return {
      type: userinfoConstants.ADD_SNSLOGIN_REQUEST,
    }
  }
  function success(response) {
    return alertActions.success({
      title: '확인',
      message: errorMessages.snsLoginState,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/change/login')
        },
      },
    })
  }
  function failure(error) {
    console.log('~~~~~~~~~~~error~~~~2~~~', error)
    return alertActions.error({
      title: '확인',
      message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/change/login')
          //history.push('/change/login')
        },
      },
    })
  }
}

/*********
 네이버 로그인
 **********/
function naverLogin(params, state) {
  return (dispatch) => {
    dispatch(request())
    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + '/portal/oauth/callback/naver?code=' + params + '&state=' + state,
      })
      .then(
        (response) => {
          console.log('~~~~~~~~~~~response~~~~~~~', response)
          dispatch(success(response))
        },
        (error) => {
          // dispatch(apiAction(userinfoConstants.ADD_SNSLOGIN_FAILURE, error))
          //dispatch(apiError(error))
          console.log('~~~~~~~~~~~error~~~~~~~', error)
          dispatch(failure(error))
        },
      )
  }
  function request() {
    return {
      type: userinfoConstants.ADD_SNSLOGIN_REQUEST,
    }
  }
  function success(response) {
    return alertActions.success({
      title: '확인',
      message: errorMessages.snsLoginState,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/change/login')
        },
      },
    })
  }
  function failure(error) {
    return alertActions.success({
      title: '확인',
      message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/change/login')
        },
      },
    })
  }
}

/*********
 sns 로그인 로딩
 **********/

function snsLoad() {
  return async (dispatch) => {
    dispatch(request())

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.GET_SNS_USERINFO,
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
          dispatch(
            alertActions.error({
              title: null,
              message: errorMessages.systemError,
            }),
          )
        },
      )
  }
  function request() {
    return {
      type: userinfoConstants.SNSINFO_LOAD_REQUEST,
    }
  }
  function success(response) {
    return {
      type: userinfoConstants.SNSINFO_LOAD_SUCCESS,
      response,
    }
  }
  function failure(response) {
    return {
      type: userinfoConstants.SNSINFO_LOAD_FAILURE,
      response,
    }
  }
}
/******
 소셜로그인연동해제
 *****/
function snsLoginDisconnect(params) {
  return async (dispatch) => {
    dispatch(apiAction(userinfoConstants.DELETE_SNSINFO_REQUEST))
    const paramStr = `?snsType=${params}`

    defaultService
      .handleService({
        method: 'get',
        endPoint: uriConstants.API_URI + uriConstants.DIS_SNSLOGIN + paramStr,
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(apiAction(userinfoConstants.DELETE_SNSINFO_FAILURE, error))
          dispatch(apiError(error))
        },
      )
  }
  function success(response) {
    return alertActions.success({
      title: '확인',
      message: errorMessages.snsLoginStateDelete,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/change/login')
        },
      },
    })
  }
}

/*********
 kakao 로그인 등록 모바일
 **********/

function addKakaoLoginMobile(params) {
  return (dispatch) => {
    dispatch(request())
    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + '/portal/oauth/addKakaoMobile?snsId=' + params,
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        },
      )
  }
  function request() {
    return {
      type: userinfoConstants.ADD_SNSLOGIN_REQUEST,
    }
  }
  function success(response) {
    return alertActions.success({
      title: '확인',
      message: errorMessages.snsLoginState,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/change/login')
        },
      },
    })
  }
  function failure(error) {
    return alertActions.error({
      title: '확인',
      message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/change/login')
          //history.push('/change/login')
        },
      },
    })
  }
}

/*********
 네이버 로그인 등록 모바일
 **********/
function addNaverLoginMobile(params, state) {
  return (dispatch) => {
    dispatch(request())
    defaultService
      .handleService({
        method: 'post',
        endPoint: uriConstants.API_URI + '/portal/oauth/addNaverMobile?snsId=' + params,
      })
      .then(
        (response) => {
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        },
      )
  }
  function request() {
    return {
      type: userinfoConstants.ADD_SNSLOGIN_REQUEST,
    }
  }
  function success(response) {
    return alertActions.success({
      title: '확인',
      message: errorMessages.snsLoginState,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/change/login')
        },
      },
    })
  }
  function failure(error) {
    return alertActions.success({
      title: '확인',
      message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError,
      params: {
        type: 'SUCCESS',
        callback: () => {
          window.location.replace('/change/login')
        },
      },
    })
  }
}
function setSignData(param) {
  // console.log(param)
  let paramsTest2={}
  Object.assign(paramsTest2,{url:'userinfo.action.jsx 729'})
  Object.assign(paramsTest2,{loginData:param})
  axios.post(uriConstants.API_URI+'/portal/blockchain/logTest',paramsTest2,{headers:{},})
  return (dispatch)=>{
    dispatch({
      type:userinfoConstants.SET_SIGNDATA,
      signData : param
    })
  }
}
